import { ModalMobile, ModalDesktop } from '@acko-tech/building-blocks.ui.modal';
import * as Styles from './styles';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import { useViewport } from 'utils/responsive';
import {
    SegmentEventNameTypes,
    SegmentEventPages,
} from 'utils/segment/constants';
import { useEffect } from 'react';

interface EmailModalProps {
    show: boolean;
    handleSubmit: () => void;
    sendSegmentEvent: (
        eventNameType: SegmentEventNameTypes,
        eventData: any,
        additionalData: any
    ) => void;
    userDetails: object;
}

const ConfirmationPopup = ({
    show,
    handleSubmit,
    sendSegmentEvent,
    userDetails,
}: EmailModalProps) => {
    const { isMobile } = useViewport();
    const Modal = isMobile ? ModalMobile : ModalDesktop;

    useEffect(() => {
        if (show) {
            sendSegmentEvent(
                SegmentEventNameTypes.VIEW,
                {
                    view_name: SegmentEventPages.COMMISSION_EARNED_V1_PAGE,
                    page_type: SegmentEventPages.GENERATE_REPORT_INFO_POPUP,
                },
                { userDetails, isMobile }
            );
        }
    }, [show]);

    return (
        <Modal
            urlhash={''}
            show={show}
            onHide={handleSubmit}
            padding={isMobile ? '24px 20px 20px' : '24px'}
            showOverlayBackground={true}
            styles={{
                maxWidth: isMobile ? '100%' : '420px',
            }}
        >
            <Styles.ModalContent>
                <Styles.ModalDescription>
                    Your request has been received, allow us a moment to prepare
                    your report. Please visit
                    <b>{` 'Report History' `}</b>
                    to check the status of your report
                </Styles.ModalDescription>
                <Styles.ButtonContainer>
                    <PrimaryButton onClick={handleSubmit} size="large">
                        {'OK'}
                    </PrimaryButton>
                </Styles.ButtonContainer>
            </Styles.ModalContent>
        </Modal>
    );
};

export default ConfirmationPopup;
